import React from "react";
import { useT } from "../i18n/I18nContext";

const STATUS_CLASSES = {
  open: "bg-emerald-50 text-emerald-700",
  accepted: "bg-amber-50 text-amber-700",
  completed: "bg-stone-100 text-stone-600",
  cancelled: "bg-stone-100 text-stone-500",
};

export default function StatusBadge({ status, testid }) {
  const t = useT();
  const cls = STATUS_CLASSES[status] || "bg-stone-100 text-stone-500";
  return (
    <span data-testid={testid} className={`text-xs px-3 py-1 rounded-full font-medium ${cls}`}>
      {t(`status.${status}`)}
    </span>
  );
}
